import { Record, List, fromJS } from 'immutable';
import DateUtilities from 'records/DateUtilities';

const defaultValues = {
  id: null,
  misId: null,
  userCategoryId: null,
  amountUnits: 0,
  archived: false,
  brand: '',
  created: null,
  createdBy: 0,
  dietaryRestriction: '',
  dietarySensitivity: '',
  ingredientName: '',
  ingredientType: '',
  note: '',
  sku: '',
  source: '',
  supc: '',
  unitCost: 0,
  updated: null,
  updatedBy: 0,
  saleDatetime: null,
  menuItemId: null,
  title: '',
  description: '',
  // size: 0,
  sizeName: '',
  numberPieces: 0,
  quantity: 0,
  price: 0,
  cost: 0,
  revenue: 0,
  profit: 0,
  ordinal: 0,
  ingredientList: new List(),
  averageProfit: 0,
  averageQuantity: 0,
  profitLevel: '',
  popularityLevel: '',
  starChartClass: '',
};

export default class MenuItemSale extends Record(defaultValues, MenuItemSale) {
  constructor(values) {
    super({
      ...values,
      ingredientList: values && values.ingredientList
                      ? fromJS(values.ingredientList)
                      : defaultValues.ingredientList,
    });
  }

  static getInitialDateFilter() {
    const date = new Date(Date.now());
    return DateUtilities.removeTime(DateUtilities.subtractMonth(date));
  }

  static getMenuItemSalesIndexByMenuItemId(menuItemSales, menuItemId) {
    return menuItemSales.findIndex(item => {
      return item.get('menuItemId') === menuItemId ? item : undefined;
    });
  }

  static getMenuItemSaleByMenuItemId(menuItemSales, menuItemId) {
    return menuItemSales.find((item) => {
      return item.get('menuItemId') === menuItemId ? item : undefined;
    });
  }

  static updateMenuItemSalesByIndex(menuItemSales, index, menuItemSale) {
    return menuItemSales.set(index, menuItemSale);
  }

  static mergeMenuItemSalesByMenuItemId(oldMenuSalesItems, newMenuSalesItems, userCategoryId) {
    let menuItemSalesData = oldMenuSalesItems.filter(o => o.get('userCategoryId') !== userCategoryId);

    newMenuSalesItems.forEach((item) => {
      const itemIndex = MenuItemSale.getMenuItemSalesIndexByMenuItemId(menuItemSalesData, item.get('menuItemId'));
      if (itemIndex >= 0) {
        menuItemSalesData = MenuItemSale.updateMenuItemSalesByIndex(
          menuItemSalesData, itemIndex, item
        );
      } else {
        menuItemSalesData = menuItemSalesData.push(item);
      }
    });

    return menuItemSalesData;
  }

  static filterByCategoryId(menusItemSales, id) {
    return menusItemSales.filter((menusItemSale) => {
      return menusItemSale.get('userCategoryId') === id;
    });
  }

  static sortMenuItemSalesByOrdinal(menusItemSales) {
    return menusItemSales.sort((itemOne, itemTwo) => {
      if (itemOne.get('ordinal') < itemTwo.get('ordinal')) return -1;
      if (itemOne.get('ordinal') > itemTwo.get('ordinal')) return 1;
      return 0;
    });
  }
}

export const MenuItemSales = (data) => {
  let menusItemSales = new List();
  if (data) {
    data.forEach((value) => {
      menusItemSales = menusItemSales.push(new MenuItemSale(value));
    });
  }
  return menusItemSales;
};
